import React from 'react';
import { clsx } from 'clsx';
import styles from './CreditLineConfirmationCosts.module.scss';
import { Icon } from '@/ui/icons/Icon';
import { Link } from 'react-router-dom';
import { routes } from '@/routes';

export interface CreditLineConfirmationCostsProps {
  contractDuration?: number;
  dailyInterestRate?: number;
  nominalAnnualPercentageRate?: number;
  effectiveAnnualPercentageRate?: number;
  className?: string;
}

export const CreditLineConfirmationCosts: React.FC<
  CreditLineConfirmationCostsProps
> = ({
  contractDuration,
  dailyInterestRate,
  nominalAnnualPercentageRate,
  effectiveAnnualPercentageRate,
  className,
}) => {
  return (
    <div className={clsx(styles.costsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Cost</h3>
      </div>

      <div className={styles.costsCard}>
        {/* Contract Duration */}
        {contractDuration && (
          <div className={styles.detailRow}>
            <div className={styles.detailLeft}>
              <p className={styles.detailLabel}>Durata contractului</p>
            </div>
            <div className={styles.detailRight}>
              <div className={styles.detailValue}>
                <span className={styles.detailText}>{contractDuration}</span>
                <span className={styles.detailUnit}>luni</span>
              </div>
            </div>
          </div>
        )}

        {/* Daily Interest Rate */}
        {dailyInterestRate && (
          <div className={styles.detailRow}>
            <div className={styles.detailLeft}>
              <p className={styles.detailLabel}>Dobânda la suma utilizată</p>
            </div>
            <div className={styles.detailRight}>
              <div className={styles.detailValue}>
                <span className={styles.detailText}>
                  {dailyInterestRate.toFixed(3)}%/zi
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Tooltip */}
      <div className={styles.tooltip}>
        <div className={styles.arrow}>
          <Icon name="vector-up" />
        </div>
        <div className={styles.tooltipContent}>
          <p className={styles.tooltipText}>
            Ai ZERO costuri atunci când nu retragi!
          </p>
        </div>
      </div>

      {/* Additional Info */}
      {nominalAnnualPercentageRate && effectiveAnnualPercentageRate && (
        <div className={styles.additionalInfo}>
          <p className={styles.infoText}>
            Rata anuală a dobânzii fixe,{' '}
            {nominalAnnualPercentageRate?.toFixed(2)}%, DAE:{' '}
            {effectiveAnnualPercentageRate?.toFixed(2)}%.
          </p>
          <Link
            to={routes.application.calculatorTab('credit-line')}
            className={styles.linkText}
          >
            Calculează costul tău lunar
          </Link>
        </div>
      )}
    </div>
  );
};
